export default {
    data() {
        return {
            active: false
        };
    },
    methods: {
        onBurgerClick() {
            this.active = !this.active;
            this.$emit("burger-click", this.active);
        }
    },
    mounted() {
        this.$root.$on("BurgerButton", () => {
            this.onBurgerClick();
        });
    }
};



// WEBPACK FOOTER //
// ./src/components/BurgerButton/BurgerButton.js